module.exports = __webpack_public_path__ + "img/chinese.250c9111.png";